// tslint:disable: no-bitwise

export enum FeatureFlags {
  None = 0,
  HelloSignTemplates = 1,
  DistributionsGP = 4,
  DocumentsManagement = 8,
  MultiUserAccount = 16,
  TransactionsLP = 32,
  EmailWhitelabeling = 64,
  Fund = 128,
  Insights = 256,
  AiRanking = 512,
  CreBanking = 1024,
  CapitalCallManualTransferPdf = 2048,
  WaterfallDistributions = 4096,
  InvestNow = 8192,
  EmailTracking = 16384,
  AssetsCapitalCommitments = 32768,
  AiService = 65536,
}

/*

// https://stackoverflow.com/questions/39359740/what-are-enum-flags-in-typescript

To assign a flag to a variable:
--------------------------------
let features = FeatureFlags.HelloSignTemplates;

To append another flag to the same variable:
--------------------------------------------
features |= FeatureFlags.LpEngagement;

To remove a flag from the variable:
--------------------------------------------
features &= ~FeatureFlags.LpEngagement;

Compare to check if a value is set in the variable:
---------------------------------------------------
console.log(FeatureFlags.HelloSignTemplates === (features & FeatureFlags.HelloSignTemplates)); // Return true
console.log(FeatureFlags.LpEngagement === (features & FeatureFlags.LpEngagement)); // Return false

*/

// tslint:disable-next-line:no-namespace
export namespace FeatureFlags {
  export function toString(ff: FeatureFlags): string {
    switch (ff) {
      case FeatureFlags.HelloSignTemplates:
        return "Signing Templates";
      case FeatureFlags.DistributionsGP:
        return "Distributions GP";
      case FeatureFlags.DocumentsManagement:
        return "Documents";
      case FeatureFlags.MultiUserAccount:
        return "Teams";
      case FeatureFlags.TransactionsLP:
        return "Transactions LP";
      case FeatureFlags.EmailWhitelabeling:
        return "Email Whitelabeling";
      case FeatureFlags.Fund:
        return "Fund";
      case FeatureFlags.Insights:
        return "Insights";
      case FeatureFlags.AiRanking:
        return "AI Ranking";
      case FeatureFlags.CreBanking:
        return "CRE Banking";
      default:
        return null;
    }
  }

  export function parse(str: string): FeatureFlags {
    return FeatureFlags[str];
  }

  export function isOn(
    featuresList: FeatureFlags,
    valueToCheck: FeatureFlags
  ): boolean {
    return valueToCheck === (featuresList & valueToCheck);
  }
}

export default FeatureFlags;
